import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import '../componentcss/Consultations.css'
// import ConsultPic from '../images/silhouette.png'
// import ConsultPic from '../images/Process.png'

function Consultations() {


    return (
        <div className="consultations">
            <Header />
            <div className="consultations-body">
                <h2 className='consultations-title'> Start Your Bespoke Journey </h2>
                <br />
                <div className='consultations'>
                    <a className='consultations-link' href='/request-quote'>Request your quote</a> and start your order today by 
                    booking a consultation with us. At SLR Couture, our bespoke service offers a fully tailored luxury experience 
                    designed to bring your unique vision to life. Whether for a special occasion or your wedding day, each garment 
                    is created to reflect your personal style and elegance. Below, we outline our exclusive consultation process to guide you through the SLR Couture journey.<br /><br />

                    <p className="consultations-header">THE BESPOKE PROCESS</p> 

                    <strong>1. In-Person & Virtual Personalized Consultation</strong><br /><br />

                    Meet directly with our designer to discuss your ideas and requirements for a one-of-a-kind creation that truly represents you. During this session, you'll have the opportunity to share inspirations, details, and preferences.<br /><br />

                    <strong>2. Custom Sketch Development</strong><br /><br />

                    A personalized design sketch will be created to visually guide the production of your garment. A detailed sketch and invoice will be provided within 7 days post consultation, depending on the complexity of the design.<br /><br />

                    <strong>3. Toile Service</strong><br /><br />
                    Every bespoke order includes a prototype (toile) of your garment. This preliminary mock-up ensures the final piece achieves a flawless, tailored fit.<br /><br />

                    <p className="consultations-header">AFTER YOUR CONSULTATION</p>

                    Upon completing your consultation, you will receive:<br /><br />

                    &#x2022; <strong>Order Confirmation</strong><br />
                    Once the deposit is received, you will receive a welcome email within 72 hours confirming your order. Please contact us if you do not receive this confirmation.<br /><br />

                    &#x2022; <strong>Order Pack</strong><br />
                    This includes a summary of your order, payment schedule, and a design sketch (for bespoke orders).<br /><br />

                    &#x2022; <strong>Invoice & Secure Payment Link</strong><br />
                    A secure payment link will be provided to submit your deposit and review our <a href="/terms" className="consultations-link">Privacy & Terms</a>. Production will only begin once the deposit has been received.<br /><br />

                    &#x2022; <strong>Measurements & Production</strong><br />
                    Upon deposit payment, measurements will be taken to begin production.<br /><br />

                    <p className="consultations-header">IMPORTANT POLICIES</p><br />

                    &#x2022; <strong>Non-Refundable Consultation Fee</strong><br />
                    Payment is required within 24–48 hours after receiving the invoice. This fee does not go towards your garment payment.<br /><br />
                    
                    &#x2022; <strong>Appointments for Clients Under 18</strong><br />
                    All bookings must be made by a parent or legal guardian.<br /><br />

                    &#x2022; <strong>Rebooking & Cancellation Fees</strong><br />
                    Same-day cancellations will incur a rebooking fee. In-person appointments are available on weekends only.<br /><br />

                    &#x2022; <strong>Shipping & International Services</strong><br />
                    Shipping fees for the final garment are not included in the initial quote and are the responsibility of the client. For additional details regarding our international fitting services, please contact us directly.<br /><br />


                    <p className="consultations-header">VIRTUAL CONSULTATIONS</p> 

                    For international or long distance clients opting for a virtual consultation, please ensure you have a measuring tape and ribbon or long string available for accurate measurements. We recommend having someone assist you during this process.<br /><br />

                    &#x2022; <strong>Virtual Fittings</strong><br /><br />
                    For clients unable to visit in person, we offer virtual fitting services. A toile will be shipped to you with a prepaid return label, and we will guide your local tailor using fitting videos.<br /><br />


                    <strong>Need Further Assistance?</strong><br /><br />

                    Email: slrcouture@gmail.com<br />
                    Phone: 678-216-7719<br /><br />

                    We aim to respond to all inquiries within 72 hours.<br />
                </div>
                <br />
                {/* <img src={ConsultPic} alt='' /> */}
                <br />
                <br />

            </div>
            {/* <img className='process' src={ConsultPic} alt='' /> */}
            <Footer />
        </div>
    );
}

export default Consultations;
